import { z } from 'zod';
import { TemplateCategorySchema } from './invitation.js';
// ============================================================
// Template Tier
// ============================================================
export const TemplateTierSchema = z.enum(['FREE', 'PREMIUM']);
export { TemplateCategorySchema };
// ============================================================
// TemplateConfig — DB templates.config JSON 스키마
// ============================================================
const ThemeVarsSchema = z.object({
    // 섹션 공통
    sectionBg: z.string().optional(),
    sectionPaddingX: z.string().optional(),
    sectionGap: z.string().optional(),
    fontFamily: z.string().optional(),
    // 섹션 타이틀
    titleFontSize: z.string().optional(),
    titleFontWeight: z.string().optional(),
    titleColor: z.string().optional(),
    titleTextTransform: z.string().optional(),
    titleLetterSpacing: z.string().optional(),
    // 구분선
    dividerWidth: z.string().optional(),
    dividerHeight: z.string().optional(),
    dividerColor: z.string().optional(),
    dividerOpacity: z.string().optional(),
    // 카드
    cardBg: z.string().optional(),
    cardRadius: z.string().optional(),
    cardShadow: z.string().optional(),
    cardBorder: z.string().optional(),
    // 버튼
    btnRadius: z.string().optional(),
    btnBg: z.string().optional(),
    btnColor: z.string().optional(),
    // 강조색
    accentColor: z.string().optional(),
}).passthrough();
const TemplateStyleSchema = z.object({
    primaryColor: z.string().optional(),
    secondaryColor: z.string().optional(),
    backgroundColor: z.string().optional(),
    fontSerif: z.string().optional(),
    fontSans: z.string().optional(),
    fontSlug: z.string().optional(),
    sectionSpacing: z.enum(['compact', 'normal', 'spacious']).default('normal'),
    themeVars: ThemeVarsSchema.optional(),
});
const SectionVariantsSchema = z.object({
    gallery: z.string().optional(), // 'grid-2'|'grid-3'|'masonry'|'carousel'... (기존 8종)
    guestbook: z.string().optional(), // 'card'|'bubble'|'minimal'
    ceremony: z.string().optional(), // 'list'|'card-pair'|'minimal'
    venue: z.string().optional(), // 'list'|'card'|'minimal'
    contacts: z.string().optional(), // 'list'|'grid'|'card'
    accounts: z.string().optional(), // 'list'|'card'|'minimal'
    schedule: z.string().optional(), // 'timeline'|'table'|'minimal'
}).optional();
export const TemplateConfigSchema = z.object({
    componentId: z.string(),
    style: TemplateStyleSchema.default({ sectionSpacing: 'normal' }),
    sectionVariants: SectionVariantsSchema,
    options: z.record(z.string(), z.unknown()).default({}),
});
/** 기본 TemplateConfig — HTML 디자인 우선 (HybridTemplate) */
export const DEFAULT_TEMPLATE_CONFIG = {
    componentId: 'html',
    style: { sectionSpacing: 'normal' },
    options: {},
};
// ============================================================
// Admin CRUD Schemas
// ============================================================
export const CreateTemplateSchema = z.object({
    name: z.string().min(1, '이름을 입력해주세요'),
    category: TemplateCategorySchema,
    tier: TemplateTierSchema.default('FREE'),
    thumbnailUrl: z.string().optional().default(''),
    config: TemplateConfigSchema,
    description: z.string().nullable().optional(),
    htmlContent: z.string().nullable().optional(),
    cssContent: z.string().nullable().optional(),
    stylesheetId: z.string().nullable().optional(),
    compositionMode: z.enum(['monolithic', 'composed']).default('monolithic'),
    isActive: z.boolean().default(true),
});
export const UpdateTemplateSchema = CreateTemplateSchema.partial();
// ============================================================
// Stylesheet CRUD Schemas
// ============================================================
export const CreateStylesheetSchema = z.object({
    type: z.enum(['html', 'css']).default('css'),
    name: z.string().min(1, '이름을 입력해주세요'),
    description: z.string().nullable().optional(),
    htmlContent: z.string().nullable().optional(), // type='html'일 때
    cssContent: z.string().optional().default(''),
    jsContent: z.string().nullable().optional(), // 공용 JS
    isActive: z.boolean().default(true),
});
export const UpdateStylesheetSchema = CreateStylesheetSchema.partial();
//# sourceMappingURL=template.js.map